var map = {
	"./music-instructions.json": 4540,
	"./music-library-intro2024.json": 4541,
	"./music-library-launch2024.json": 4542,
	"./music-progression.json": 4543,
	"./startSourcesAdvanced.json": 4544,
	"./startSourcesSimple.json": 4545,
	"./startSourcesSimple2.json": 4546,
	"./startSourcesTracks.json": 4547
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4306;